module.exports = __webpack_public_path__ + "img/talk_2.f5efd1ad.png";